import { render, staticRenderFns } from "./search-history.vue?vue&type=template&id=57a7b74b&scoped=true&"
import script from "./search-history.vue?vue&type=script&lang=js&"
export * from "./search-history.vue?vue&type=script&lang=js&"
import style0 from "./search-history.vue?vue&type=style&index=0&id=57a7b74b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a7b74b",
  null
  
)

export default component.exports